<template>
  <form-wrapper :validator="$v.manzel">

    <b-form-row>
      <b-col
        v-for="(item, key) in cols"
        :key="key">
        <text-group
          v-for="(i, k) in item"
          :key="k"
          :class="i.class"
          :align-right="i.alignRight"
          :m="manzel"
          :name="k"
          :label="i.label"
          :input-group="k === 'm_vlatne_prijmy'"
        />
      </b-col>
    </b-form-row>

    <b-button
      class="btn-primary"
      @click="save">
      {{ $t('message.lblSave') }}
    </b-button>

    <b-tooltip
      target="info"
      placement="right"
      :title="$t('message.tooltipManzel')"
    />

  </form-wrapper>
</template>

<script>
import { maxLength, minValue, maxValue, decimal } from 'vuelidate/lib/validators'
import textGroup from '@/components/extractor/textGroup.vue'
import restEditor from '@/mixins/restEditor'
import { containsNumber } from '@/validators'

function manzelData() {
  return {
    m_priezvisko_meno: null,
    m_rc: '',
    m_mesiace_spoluzitia: null,
    m_vlatne_prijmy: null,
    ks_partner: null
  };
}

export default {
  components: {
    textGroup
  },

  mixins: [restEditor],

  data() {
    return {
      manzel: manzelData(),
      cols: {
        col1: {
          m_priezvisko_meno: { class: 'required', label: this.$t('message.lblPriezMeno'), alignRight: false },
          m_rc: { class: 'required', label: this.$t('message.lblRc'), alignRight: false },
          ks_partner: { label: this.$t('message.lblKs') }
        },
        col2: {
          m_vlatne_prijmy: { label: this.$t('message.lblVlstPrijmy') },
          m_mesiace_spoluzitia: { label: this.$t('message.lblMesiac') }
        },
      },
    }
  },

  validations: {
    manzel: {
      m_priezvisko_meno: {
        containsNumber,
        maxLength: maxLength(60)
      },
      m_rc: {},
      m_vlatne_prijmy: {
        decimal,
        maxValue: maxValue(3830.02),
        minValue: minValue(0)
      },
      m_mesiace_spoluzitia: {
        decimal,
        maxValue: maxValue(12),
        minValue: minValue(0)
      },
      ks_partner: {
        decimal,
        maxValue: maxValue(50),
        minValue: minValue(0)
      },
    },
  },

  methods: {
    async processGet() {
      this.manzel = await this.restDataSource.getData(this.$route.params.userId, 'partners')
    },
    async processSave() {
      await this.restDataSource.updateData(this.manzel, 'partners')
    },
  },
};
</script>
